'use client'

import { storyblokEditable } from '@storyblok/react/rsc'
import { type FC } from 'react'

import { type StoryblokComponentProps } from '../../model'
import { type StoryblokBrandImageCardType } from '../../storyblok'
import { useStoryblokWebOrAppLink } from '../../useStoryblokLink'
import { StoryblokComponentsRenderer } from '../StoryblokComponentsRenderer'

export const StoryblokBrandImageCard: FC<
  StoryblokComponentProps<StoryblokBrandImageCardType>
> = ({ blok }) => {
  const { appHref, href, image } = blok
  const { url } = useStoryblokWebOrAppLink({ appLink: appHref, link: href })

  if (!url) {
    return null
  }

  return (
    <a
      {...storyblokEditable(blok)}
      className="block h-[170px] rounded-xl border border-dark-primary-strong p-6"
      href={url}
    >
      <div className="relative min-h-full min-w-full">
        <StoryblokComponentsRenderer bloks={image} />
      </div>
    </a>
  )
}
